'use strict';

// scroll to top
(function($) {
  $('#js-page-top').on('click', function() {
    $('html, body').animate({scrollTop: 0}, 400);

    return false;
  });
})(jQuery);

// phone link
if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
  $(function() {
    $('.tel').each(function() {
      let str = $(this).html();
      if ($(this).children().is('img')) {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
      } else {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
      }
    });
  });
}

// home
(function($) {
  if (!$('body.home').length) return;

  let $window = $(window);
  let $nav = $('.js-scroll');
  let $navGlobal = $('#js-nav');
  let $navAnchors = $nav.find('a');

  $window.on('load', function() {
    let navHeight = $navGlobal.height();

    if (location.hash) {
      $window.scrollTop($(location.hash).offset().top - navHeight);
      history.replaceState(null, null, location.pathname);
    }

    $navAnchors.on('click', function() {
      let href = $(this).attr('href').match(/^.*(#.+)$/)[1];

      $('html, body').animate({
        scrollTop: $(href).offset().top - navHeight
      }, 400);

      return false;
    });

    {
      let offsetTop = $nav.offset().top;

      $window.on('scroll', function() {
        if ($window.scrollTop() > offsetTop) {
          $nav.addClass('is-fixed');
        } else {
          $nav.removeClass('is-fixed');
        }
      }).trigger('scroll');
    }

    {
      let sections = {};

      $window.on('resize', function() {
        $($navAnchors.get().reverse()).each(function() {
          let key = $(this).attr('href');
          //sections[key] = $(key.match(/^.*(#.+)$/)[1]).offset().top - navHeight - 10;
        });
      }).trigger('resize');

      $window.on('scroll', function() {
        let hasActiveNav = false;

        for (let key in sections) {
          let value = sections[key];

          if (value < $window.scrollTop()) {
            $navAnchors.removeClass('is-active');
            $navAnchors.filter(`[href="${key}"]`).addClass('is-active');
            hasActiveNav = true;
            break;
          }
        }

        if (!hasActiveNav) {
          $navAnchors.removeClass('is-active');
        }
      }).trigger('scroll');
    }


    // よくあるご質問：アコーディオン
    let $btn = $('.faq__list__q');
    let closeClass = 'faq__list__q--close';

    $('.faq__list__a').hide();
    $btn.on('click', function (evt) {
      let $this = $(this);
      let $body = $this.next();

      $body
        .stop(true, true)
        .slideToggle(400);
      $this.toggleClass(closeClass);

      return false;
    });

  });
})(jQuery);
